export default "__VITE_ASSET__IPNc6auL__"